import { Button } from "@mdotm/shadcn/mdotm/components";
import { Dialog, DialogFooter, Text } from "@mdotm/shadcn/legacy/components";
import { useTranslation } from "react-i18next";

/**
 * Shown when the AUM of a portfolio in quantities could not be read: cash is derived from it, so the
 * review cannot be shown without it. It has no close: the only way out is the list it names.
 */
export function AumUnavailableDialog(props: { show: boolean; onLeave(): void }): React.JSX.Element {
	const { t } = useTranslation();
	return (
		<Dialog
			show={props.show}
			header={t("EDIT_COMPOSITION.REVIEW_QUANTITY.AUM_UNAVAILABLE.TITLE")}
			footer={
				<DialogFooter
					primaryAction={
						<Button palette="primary" onClick={props.onLeave} data-qualifier="ReviewInstruments/AumUnavailable/Leave">
							{t("EDIT_COMPOSITION.REVIEW_QUANTITY.AUM_UNAVAILABLE.LEAVE")}
						</Button>
					}
				/>
			}
		>
			<Text as="p" type="Body/M/Book">
				{t("EDIT_COMPOSITION.REVIEW_QUANTITY.AUM_UNAVAILABLE.BODY")}
			</Text>
		</Dialog>
	);
}
